var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseTender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E64A0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9982 29.0038H12.9969C11.8919 29.0038 10.9961 28.108 10.9961 27.0029V12.9971C10.9961 11.8921 11.8919 10.9963 12.9969 10.9963H24.0015C25.1065 10.9963 26.0023 11.8921 26.0023 12.9971V15.9984",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7725 23.1613L28.4561 26.2786C28.898 26.6503 29.0959 27.2374 28.9692 27.8008C28.8424 28.3642 28.4121 28.81 27.8536 28.9565C27.295 29.1031 26.7013 28.9261 26.3142 28.4975L23.0488 24.902",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.998 15.9984H21.0005",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.998 20H16.9989",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9246 21.8618L19.459 23.0293C19.1884 23.2464 19.0229 23.5684 19.0038 23.9148C18.9847 24.2613 19.1139 24.5995 19.359 24.845L20.4745 25.9655C20.7175 26.2097 21.0533 26.3384 21.3973 26.3193C21.7413 26.3002 22.0607 26.135 22.2752 25.8654L23.4517 24.4018C23.7315 24.0541 24.0489 23.7384 24.3981 23.4604L25.8637 22.292C26.1343 22.075 26.2998 21.7532 26.3189 21.4069C26.338 21.0606 26.2088 20.7226 25.9637 20.4772L24.8523 19.3557C24.6092 19.1115 24.2735 18.9828 23.9295 19.0019C23.5855 19.021 23.266 19.1862 23.0515 19.4558L21.871 20.9204C21.5909 21.2678 21.2736 21.5835 20.9246 21.8618V21.8618Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9227 28.9838H19.9219",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseTender);
export default __webpack_public_path__ + "static/media/CloseTender.a1dd356fd9e7124a82d4d048b55d83cc.svg";
export { ForwardRef as ReactComponent };